<template>
  <div class="menu-side">
    <div class="menu-side-title">
      <img
        class="icon-back"
        src="../../assets/imgs/icon_back.png"
        alt=""
        @click="onClick('hide_menu')"
      />
      <div class="user-info">
        <img src="../../assets/imgs/avatar.png" alt="" />
        <span v-if="user && user.pname">{{ user.pname }}</span>
        <span v-else @click="goRouter('/login')">{{ i18n.login_tips }}</span>
        <!-- <span class="user-info-edit">{{ i18n.edit_profile }}</span> -->
      </div>
    </div>
    <!-- <div class="menu-side-title">
      <img src="../../assets/imgs/avatar.png" alt="">
      <div>
        <span v-if="user && user.pname">{{user.pname}}</span>
        <span v-else @click="goRouter('/login')">{{i18n.login_tips}}</span>
      </div>
    </div> -->
    <div class="menu-side-block">
      <div class="menu-side-row" @click="goRouter('/order')">
        <img src="../../assets/imgs/history.png" alt="" />
        <span>{{ i18n.order }}</span>
      </div>
      <div class="menu-side-row" @click="goRouter('/payment_card')">
        <img src="../../assets/imgs/wallet.png" alt="" />
        <span>{{ i18n.payment_title }}</span>
      </div>
      <div class="menu-side-row" @click="goRouter('/help')">
        <img src="../../assets/imgs/help.png" alt="" />
        <span>{{ i18n.help }}</span>
      </div>
    </div>
    <div class="menu-side-list">
      <div class="menu-side-row" @click="goRouter('/setting')">
        <img src="../../assets/imgs/setting.png" alt="" />
        <span>{{ i18n.setting }}</span>
      </div>
      <div class="menu-side-row" @click="aboutus">
        <img src="../../assets/imgs/aboutus.png" alt="" />
        <span>{{ i18n.aboutus }}</span>
      </div>
      <div class="menu-side-row" @click="onLogout">
        <img src="../../assets/imgs/logout.png" alt="" />
        <span>{{ i18n.logout }}</span>
      </div>
    </div>
    <!-- <div class="menu-side-row">
      <img src="../../assets/imgs/coupon.png" alt="">
      <span>优惠券</span>
    </div> -->
    <div class="menu-side-foot"></div>
  </div>
</template>

<script>
import { mapState } from "vuex"
export default {
  computed: {
    ...mapState(["user"]),
    i18n() {
      return this.$t("mine")
    }
  },
  methods: {
    onClick(type) {
      if (type === "hide_menu") {
        // this.$parent.$parent.isMenuView = false
        this.$emit("close")
      }
      if (type === "join_us") {
        let domain = process.env.VUE_APP_DOMAIN.replace("//m.", "//www.")
        window.open(domain)
      }
    },
    onLogout() {
      this.$store.commit("user", null)
      this.$store.commit("token", "")
      this.$router.push("/login")
    },
    goRouter(path) {
      this.$router.push(path)
    },
    aboutus() {
      window.open(process.env.VUE_APP_WEBSITE)
    }
  }
}
</script>

<style lang="less">
.menu-side {
  width: 100%;
  .icon-back {
    width: 80px;
    height: 80px;
    margin-bottom: 50px;
  }
  &-title {
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 40px 53px 32px;
  }
  .user-info {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 42px;
    img {
      width: 140px;
      height: 140px;
      margin-right: 20px;
      border-radius: 50%;
      margin-bottom: 26px;
    }
    &-edit {
      font-size: 24px;
    }
  }
  &-block {
    border-radius: 20px;
    padding: 20px 30px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 20px 40px;
    background: #f8f6fc;
    .menu-side-row {
      text-align: center;
      display: initial;
      height: inherit;
      img {
        display: block;
        margin: 0 auto;
        width: 100px;
        height: 100px;
      }
    }
  }
  &-list {
    padding: 20px 0;
    border-radius: 20px;
    margin: 30px 40px 0;
    background: #f8f6fc;
  }
  &-row {
    font-size: 32px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 100px;
    img {
      width: 60px;
      height: 60px;
      margin: 0 20px 0 28px;
    }
  }
  // &-foot {
  //   // width: 100%;
  //   // position: absolute;
  //   // bottom: 96px;
  // }
}
</style>
